import { render, staticRenderFns } from "./examinkslis.vue?vue&type=template&id=fe827fb4&scoped=true"
import script from "./examinkslis.vue?vue&type=script&lang=js"
export * from "./examinkslis.vue?vue&type=script&lang=js"
import style0 from "./examinkslis.vue?vue&type=style&index=0&id=fe827fb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe827fb4",
  null
  
)

export default component.exports